import { render, staticRenderFns } from "./DraftMessage.vue?vue&type=template&id=94a144e0&"
import script from "./DraftMessage.vue?vue&type=script&lang=js&"
export * from "./DraftMessage.vue?vue&type=script&lang=js&"
import style0 from "./DraftMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports